const PUBLIC_GOOGLE_TAG_ID = 'AW-17980386563';
const GOOGLE_TAG_SCRIPT_PREFIX = 'https://www.googletagmanager.com/gtag/js?id=';

function ensureGoogleTagScript() {
  const existingScript = document.querySelector(`script[src^="${GOOGLE_TAG_SCRIPT_PREFIX}"]`);
  if (existingScript) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `${GOOGLE_TAG_SCRIPT_PREFIX}${PUBLIC_GOOGLE_TAG_ID}`;
  document.head.appendChild(script);
}

function ensureGtagFunction() {
  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  return window.gtag;
}

export function syncPublicGoogleTag(path) {
  const normalizedPath = typeof path === 'string' && path ? path : '/';
  const isAdminRoute = normalizedPath === '/admin' || normalizedPath.startsWith('/admin/');

  if (isAdminRoute || window.__edenaPublicGoogleTagConfigured) {
    return;
  }

  ensureGoogleTagScript();
  const gtag = ensureGtagFunction();
  gtag('config', PUBLIC_GOOGLE_TAG_ID);
  window.__edenaPublicGoogleTagConfigured = true;
}
